import { ActivatedRoute, Router } from '@angular/router';
import { MaterialService } from '../../../services/material.services';
import Swal from 'sweetalert2';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VersionImgSliderComponent } from '../../shared/version-img-slider/version-img-slider.component'
import { AfterViewInit, Component, ElementRef,ViewChild, } from '@angular/core';
import { MainService } from '../../../services/main.services';

@Component({
  selector: 'app-material-list',
  templateUrl: './material-list.component.html',
  styleUrl: './material-list.component.scss'
})
export class MaterialListComponent {
  constructor(private router: Router,
              private _params: ActivatedRoute,
              private matService : MaterialService,
              private dialogService: DialogService,
              private mainService : MainService) {
                   this._params.params.subscribe((params : any) => {
                    if(params.camp_id && params.box_id){
                      this.camp_id_nest = params.camp_id;
                      this.box_id = params.box_id;
                    }else{
                      Swal.fire({
                      title: 'Error',
                      text: 'Se han proporcionado datos incorrectos',
                      icon: 'error',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      allowEnterKey: false,
                      showConfirmButton: false,
                      showCloseButton: false
                    });
                    }

                   });
              }

    camp_id_nest = 0;
    camp_id_claw = 0;
    box_id = 0;
    loaded : boolean = false;
    ref: DynamicDialogRef | undefined;
    box  : any = {hoot_status : 0};
    materials : Array<any> = [
  ];
  totalCapturadas: number = 0;
  totalVersiones: number = 0;


  
  ngOnInit(): void {
    this.getVersions();
    this.matService.capturedImage = ""
    this.matService.croppedImage  = ""
   //let algo = this.mainService.serializeObj(JSON.parse("{\"apiRes\":{\"id\":408,\"idCampana\":44,\"idGrupo\":5,\"imgCompleta\":\"https://buho.nyc3.digitaloceanspaces.com/buho-hoot/campanas/44/captura_inicial/completa/grupo_5_1759527883554.png\",\"imgRecorte\":\"https://buho.nyc3.digitaloceanspaces.com/buho-hoot/campanas/44/captura_inicial/recorte/grupo_5_1759527883554.png\",\"texto\":\"110\\nZ\\nอ\\nM\\nI\\nN\",\"status\":0,\"createdAt\":\"2025-10-03T21:44:43.000Z\"},\"data\":{\"material_img\":\"https://nyc3.digitaloceanspaces.com/buho/buho-claw/pnp/TEST-HOOT/surveys/materials/20251002203928_DANGLER-1.png\",\"mat_nombre\":\"DANGLER\",\"mat_id\":0,\"camp_id\":32,\"box_id\":\"44939\",\"version\":null}}"))
   //console.log(algo);
  }

  getVersions(){
     Swal.fire({
         title: 'Cargando materiales...',
         text: 'Esto puede tardar unos segundos',
         allowOutsideClick: false,
         didOpen: () => {
           Swal.showLoading();
         }
     });
   this.matService.getBoxData(this.camp_id_nest, this.box_id).subscribe((x:any)=>{
    console.log(x.message, x.data);
    if(x.message === 'Success'){
        this.materials = x.data 
        this.camp_id_claw = x.box.id_campana_claw;
        this.camp_id_nest = x.box.id_campana_nest;
        this.loaded = true;
        this.box = x.box;
        this.totalVersiones = this.materials.reduce((totalV, item) => totalV + item.versiones.length, 0);
        this.totalCapturadas = this.materials.reduce((totalC, item) => totalC + item.capturas, 0);

        Swal.close();
    }else{
      Swal.close();
      Swal.fire('Error', 'Oops, algo salió mal, por favor intente más tarde', 'error');
    }
   });
  }

  onOpenImage(item : any){
    if(item.versiones.length != 0){
      this.ref = this.dialogService.open(VersionImgSliderComponent, {
      header: 'Versiones',
      width: '700px',
      contentStyle: { 'max-height': '790px', overflow: 'auto' },
             breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
      baseZIndex: 10000,
      data: item.versiones
    });
    }else{
        Swal.fire({
        title: 'Aviso',
        text: 'Este material no tiene imágenes para mostrar',
        icon: 'warning',
       });
    }

  }
// onCapture(item: any) {
//   console.log('Capturar', item);
//   this.router.navigate(['/material-scan']);
// }

  onCapture(item:any){
     const data = {
      claw_camp_id: this.camp_id_claw,
      camp_id: this.camp_id_nest,
      id_grupo: item.id,
      mat_nombre: item.nombre,
      material_img : item.versiones[0]?.url || 'assets/images/example-mat.png',
      box_id : this.box_id,
      mat_id: 0,
      version : null
    };

    let dataStr = this.mainService.serializeObj(data);
    this.router.navigate(['/material-scan/' + dataStr ]);
     //this.router.navigate(['/material-scan/' + this.camp_id_claw + '/' +  this.camp_id_nest + '/' + item.id + '/' + item.nombre + '/' + 0 ]);
  }

  omitGroup(item:any){
        Swal.fire({
        text: '¿Está seguro que desea omitir los materiales de este grupo?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: {
          popup: 'swal-font',
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn'
        },
        buttonsStyling: false,
        reverseButtons: true 
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
              title: 'Ejecutando proceso...',
              text: 'Esto puede tardar unos segundos',
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
          });
          this.matService.omitGroup(this.camp_id_claw, this.box_id, item.id, this.camp_id_nest).subscribe({
            next: (x: any) => {
              console.log(x.message, x.data);
              if (x.message === 'Success') {
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  title: '¡Proceso completado!',
                  text: 'Se han omitido los grupos correctamente.',
                  confirmButtonText: 'Aceptar'
                }).then(r => {
                 
                  this.getVersions();
                });
              } else {
                Swal.close();
                Swal.fire({
                  icon: 'error',
                  title: 'Error al omitir',
                  text:  'Intenta nuevamente más tarde.',
                  confirmButtonText: 'Aceptar'
                });
              }
            },
            error: (err) => {
              console.error('Error en omitGroup:', err);
              Swal.fire({
                icon: 'error',
                title: 'Error al omitr',
                text: 'Intenta nuevamente más tarde.',
                confirmButtonText: 'Aceptar'
              });
            }
          });
        }
      });
  }

    omitBox(){
        Swal.fire({
        text: '¿Está seguro que desea finalizar la caja? Las capturas pendientes serán marcadas como omitidas.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: {
          popup: 'swal-font',
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn'
        },
        buttonsStyling: false,
        reverseButtons: true 
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
              title: 'Ejecutando proceso...',
              text: 'Esto puede tardar unos segundos',
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
          });
          this.matService.omitBox(this.camp_id_claw, this.box_id, this.camp_id_nest).subscribe({
            next: (x: any) => {
              console.log(x.message, x.data);
                 
              if (x.message === 'Success') {
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  title: '¡Proceso completado!',
                  text: 'Se han finalizado la caja correctamente.',
                  confirmButtonText: 'Aceptar'
                }).then(r => {
                 
                  this.getVersions();
                });
              } else {
                Swal.close();
                Swal.fire({
                  icon: 'error',
                  title: 'Error al finalizar',
                  text:  'Intenta nuevamente más tarde.',
                  confirmButtonText: 'Aceptar'
                });
              }
            },
            error: (err) => {
              console.error('Error en omitGroup:', err);
              Swal.hideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al finalizar',
                text: 'Intenta nuevamente más tarde.',
                confirmButtonText: 'Aceptar'
              });
            }
          });
        }
      });
  }


  onVersionList(item:any){
     this.router.navigate(['material-version-list/'+ this.camp_id_claw  + '/' + this.camp_id_nest + '/' + this.box_id + '/'+ item.id]);
  }

  canOmit(item : any){
    return item.versiones.some((x:any)=> x.omitable == true);
  }

  get progress(){
    return Math.round((this.totalCapturadas / this.totalVersiones) * 100);
  }
}
